export default __webpack_public_path__ + "7d3ba9ff2ac2797c5acc2de143f1539b.svg";